import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { EnfermeraService } from 'src/app/services/enfermera.service';
import { Enfermera } from 'src/app/models/enfermera.interface';
import { AuthService } from 'src/app/services/auth.service';
import { DESCRIPCION_CANJES } from 'src/app/shared/constantes/constants';
import { Paginar } from 'src/app/models/http-paginacion.interface';
import { CasoClinico, CasoClinicoFormatoXLS } from 'src/app/models/caso-clinico.interface';
import { DESCRIPCION_STATUS_CANJE } from 'src/app/shared/constantes/constants';
@Component({
  selector: 'app-enfermera-casosclinicos',
  templateUrl: './enfermera-casosclinicos.component.html',
  styleUrls: ['./enfermera-casosclinicos.component.scss']
})
export class EnfermeraCasosclinicosComponent {
  casosClinicos: CasoClinico[] = [];
  canjes: string[] = [...DESCRIPCION_CANJES];
  enfermera!: Enfermera;

  currentPageCasosClinicos: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsCasosClinicos: number = 10;
  statusCanje: string[] = [...DESCRIPCION_STATUS_CANJE];

  get casosclinicos(): CasoClinico[] {
    const startIndex = (this.currentPageCasosClinicos.page) * this.currentPageCasosClinicos.rows;
    return this.enfermera.casosclinicos.slice(startIndex, startIndex + this.currentPageCasosClinicos.rows);
  }
  get totalPaginasCasosClinicos(): number {
    return Math.ceil(this.enfermera.casosclinicos.length / this.currentPageCasosClinicos.rows);
  }

  constructor(private enfermeraService: EnfermeraService, private authService: AuthService, private messageService: MessageService,) {
    if (this.authService.getLoggedIn) {
      const idEnfermera = this.authService.getUsuario?.enfermera?.id;
      if (idEnfermera) this.obtenerInformacion(idEnfermera);
    }
  }

  obtenerInformacion(id: number): void {

    this.enfermeraService.getEnfermera(id).subscribe({
      next: (resp) => {
        this.inicarInformacion(resp.datos);
      },
      error: (err) => console.log(err)
    });
  }
  inicarInformacion(enfermera: Enfermera): void {
    this.casosClinicos.push(...enfermera.casosclinicos);
    this.enfermera = enfermera;
    this.totalItemsCasosClinicos = enfermera.casosclinicos.length;
  }
  onPageChangeCasosClinicos(event: any) {
    this.currentPageCasosClinicos = <Paginar>event;
  }
  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }
  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }
  getCanje(id: number): string {
    return this.canjes[id];
  }
  exportExcel(): void {
    const EXCEL_EXTENSION = '.xlsx';
    const casosClinicos: CasoClinicoFormatoXLS[] = this.fullCasosClinicosXLSX(this.enfermera.casosclinicos);
    const nombreEnfermera = [{ campo: "Enfermera", nomEnfermera: this.enfermera.nom_enfermera }];
    const fileName = 'enfermera-casosclinicos';

    import('xlsx').then((XLSX) => {
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_json(ws, nombreEnfermera, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_json(ws, casosClinicos, { origin: "A4" });
      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'casos_clinicos');
      /* save to file */

      XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  fullCasosClinicosXLSX(casoclinico: CasoClinico[]): CasoClinicoFormatoXLS[] {
    const casosclinicosxlsx: CasoClinicoFormatoXLS[] = casoclinico.map((item) => {
      return <CasoClinicoFormatoXLS>{
        fecha: item.fecha,
        folio: item.folio,
        serie: item.serie,
        paciente: item.paciente,
        sexo: item.sexo,
        edad: item.edad,
        antecedente: item.antecedente,
        institucion: item.cveInstitucion,
        hospital: item.nomHospital,
        fechaAplicacionProducto: item.fechaAplicacionProducto,
        diagnostico: item.diagnostico,
        antibiotico1: item.nomAntibiotico1,
        cantidad1: item.cantidad1,
        antibiotico2: item.nomAntibiotico2,
        cantidad2: item.cantidad2,
        antibiotico3: item.nomAntibiotico3,
        cantidad3: item.cantidad3,
        tratamiento: item.tratamiento,
        cuerpo: item.nomCuerpo,
        observacion: item.observacion,
        status: this.statusCanje[item.status_canje],
        medico: item.medico.nom_medico,
        productos: item.productos.length,
        documentos: item.documentos.length
      }
    });
    return casosclinicosxlsx;
  }

}
